import React, { useState, useEffect } from "react";
import axios from "axios";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Clearfix from "components/Clearfix/Clearfix.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";

import styles from 'views/component/Styles.js';
import Confirm from 'views/component/Confirm.js';

const useStyles = makeStyles(styles);

export default function People() {
  const classes = useStyles();

  const [userInfo, setUserInfo] = useState({});
  const [userConfirm, showUserConfirm] = useState(false);

  useEffect(() => {
    axios.get('data/auth/list')
      .then(response => {
        const userId = window.sessionStorage.getItem("userId");
        setUserInfo(response.data.filter(item => item.userId === userId)[0]);
      });
  }, []);

  const onPasswordChange = function (value) {
    userInfo.password = value;
  };

  const onUserConfirm = function (result) {
    if (result) {
      axios.post('data/auth/listedit', [userInfo])
        .then(response => {
          alert('변경하였습니다')
        });
    }
    showUserConfirm(false);
  };

  return (
    <div>
      <Confirm show={userConfirm} title="비밀번호 저장" text="비밀번호를 저장합니다."
        onConfirm={onUserConfirm} confirmText="저장" type="info" />
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <Card>
            <CardHeader color="rose" icon>
              <h4 className={classes.cardIconTitle}>
                <b>비밀번호 수정</b>
              </h4>
            </CardHeader>
            <CardBody>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText={window.sessionStorage.getItem("userId")}
                    id="userId"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{ disabled: true }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Password"
                    id="password"
                    underlineColor="info"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "password",
                      onChange: event => {
                        if (event.target.value) {
                          onPasswordChange(event.target.value);
                        }
                      }
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer justify="center">
                <Button color="info" onClick={e => { showUserConfirm(true); }}>비밀번호 저장</Button>
              </GridContainer>
              <Clearfix />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
